import { _, Backbone, moment, Radio } from "../../../vendor";
import { Backform, Biscuit, Notification } from "../../utils";
import OffCanvasContingentsFormTpl from "../../templates/contingents/OffCanvasContingentsFormTpl.html";
import InboomaBaseView from "../InboomaBaseView";
import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

import ContingentNumbersList from "./ContingentNumbersList";

import Resource from "../../models/Resource";
import Contingent from "../../models/Contingent";
import Resourcetypes from "../../collections/Resourcetypes";

export default InboomaBaseView.extend({
  // @todo if edit appointment: show amount field!
  // @todo new added contingents should update locations collection
  template: OffCanvasContingentsFormTpl,
  el: "#inb-off-canvas",
  parentView: "contingents",

  templateContext() {
    return {
      client_id: Biscuit.get("user.client_id"),
    };
  },
  _autoGenerateAmount: 0,

  behaviors: [
    {
      behaviorClass: OffCanvasBehavior,
      beforeSave: (model, view) => {
        const contingentAmounts = view.contingentNumbersList.returnFormattedContingentAmounts();

        view._pricetariffs = model.get("pricetariffs");
        delete model.attributes.description;
        delete model.attributes.image;
        delete model.attributes.pricetariffs;
        if (model.attributes.fe_visible) {
          model.set("fe_visible", 1);
        } else {
          model.set("fe_visible", 0);
        }
        if (model.get("id") === null) {
          if (model.get("do_bulk_action")) {
            view._autoGenerateAmount = contingentAmounts[0].number;
          }

          delete model.attributes.do_bulk_action;

          model.set("client_id", Number(Biscuit.get("user.client_id")));
          //model.set('resources', []); // fixes #18088, though should be collection
        }

        delete model.attributes.resources;
        delete model.attributes.products;
        // API'ify (though mostly done in Backform.ts)
        // @todo Replace by more functional approach
        let new_locations = [];

        _.each(model.get("locations"), (location) => {
          new_locations.push({
            id: location.id,
          });
        });

        model.set("locations", new_locations);

        model.set("contingent_numbers", contingentAmounts);
      },
      afterSaveSuccess: (model, view, response) => {
        // Refetch model as response does only contain ID :(
        model.fetch({
          success() {
            model.clearFormat();

            // @todo refactor, as #18088 showed some problems

            // In future, if possible, we should better leave resources[] in the model
            if (view._autoGenerateAmount >= 1) {
              // Auto-generate resources

              for (var i = 0; i < view._autoGenerateAmount; i++) {
                let res = new Resource({
                  id: "", // @todo location_id
                  location_id: model.get("locations")[0]["id"],
                  contingent_id: Number(model.get("id")),
                  client_id: Number(Biscuit.get("user.client_id")),
                });

                delete res.attributes.created;
                delete res.attributes.modified;
                delete res.attributes.deleted;

                res.save(null, {
                  type: "POST",
                  success(_model, response, options) {
                    console.log("success adding resource", _model);
                    model.attributes.resources.push(_model);
                    model.trigger("changed");
                  },
                  error(_model, response, options) {
                    console.log("error adding resource", _model, response);
                  },
                });
              }
            }

            view.collection.set(model, { add: true, merge: true, remove: false });
            view.options.afterSave(view.options.collection, model.get("id"));
            // Trigger update fetch on locations coll

            new Notification({
              message: view.t(
                view.isNew ? "saved_${a}" : "updated_${a}",
                { a: view.t("contingent") },
                "capital",
              ),
              duration: 5000,
              type: "success",
              closeable: true,
              icon: "fi fi-check",
            });
          },
          error() {
            alert("e");
          },
        });
      },
      afterSaveError: (model, view, response) => {
        let message = view.t("request_error");

        if (typeof response.responseJSON !== "undefined") {
          const data = response.responseJSON.data;

          if (typeof data !== "undefined" && typeof data.message !== "undefined") {
            message = data.message;
          }
        }
        let duration = 5000;
        if (typeof response.status !== "undefined" && response.status === 400) {
          duration = 50000;
        }
        new Notification({
          message,
          duration: duration,
          type: "warning",
          closeable: true,
          icon: "fi fi-check",
        });
      },
    },
  ],

  initialize() {
    this.render();
  },

  onRender() {
    this.isNew = this.model.get("id") == "";

    const that = this,
      locations = Radio.channel("locations").request("get:data"),
      resourcetypes = Radio.channel("resourcetypes").request("get:data");

    let fields = [
      {
        name: "name",
        label: this.t("contingent_name", null, "capital"),
        control: "input",
        required: true,
        size: {
          large: "5",
          small: "12",
        },
      },
      /*{
        name : "description",
        label : this.t('description',null,'capital'),
        control: "input", 
        size : {
          "large" : "7"
        }
      },*/ {
        name: "resourcetype_id",
        label: this.t("resourcetype", null, "capital"),
        control: "selector",
        required: true,
        forceFirstSelected: true,
        disabled: that.model.get("id") != "",
        options: _.map(resourcetypes.models, (rt, key) => {
          if (rt.get("id") !== 2) {
            // Hide "Unterkünfte"
            return {
              label: that.t(rt.get("name").toLowerCase(), null, "capital"),
              value: rt.get("id"),
            };
          }
          return {};
        }),
        size: {
          large: "4",
          small: "12",
        },
        groupLabel: '<i class="fi fi-widget"></i>',
      },
      {
        name: "locations",
        label: this.t("location", null, "capital"),
        helpMessage: this.t("contingent_location_help"),
        forceFirstSelected: true,
        required: true,
        hasMultiple: () =>
          that.model.get("resourcetype_id") === 3 || that.model.get("resourcetype_id") === 1
            ? 999
            : 1,
        //visible: () => (that.model.get('resourcetype_id') != 4),
        placeholder: this.t("select_${a}", { a: this.t("location") }),
        options: _.map(locations.models, (location, key) => {
          return { label: location.get("name"), value: location.get("id") };
        }),
        size: {
          large: "8",
          small: "12",
        },
        control: Backform.SelectorControl.extend({
          _toggleHelpText() {
            if (that.model.get("resourcetype_id") == 3) {
              that.$el.find(".locations .help-text").removeClass("hide");
            } else {
              that.$el.find(".locations .help-text").addClass("hide");
            }
          },
          initialize() {
            Backform.SelectorControl.prototype.initialize.apply(this, arguments);
            this._toggleHelpText();

            this.listenTo(this.model, "change:resourcetype_id", function () {
              // Make sure aboves field options become re-checked
              this.render();
              this._toggleHelpText();
            });
          },
        }),
      },
      {
        name: "fe_visible",
        label: this.t("fe_visible", null, "capital"),
        control: "boolean",
        size: {
          large: "6",
        },
      },
    ];

    if (this.model.get("id") === "") {
      this.model.set("do_bulk_action", true);

      fields.push({
        name: "do_bulk_action",
        label: this.t("autogenerate_resources"),
        helpMessage: this.t("autogenerate_resources_body"),
        control: "boolean",
        size: {
          large: "6",
        },
        extraTopClasses: ["depend-non-appointment"],
      });
    }

    this.form = new Backform.Form({
      el: that.$("#contingents-form"),
      collection: that.collection,
      model: that.model,
      fields,
    }).render();

    if (this.model.get("id") !== "") {
      _.each(this.model.get("contingent_numbers"), (contingentNumber) => {
        if (contingentNumber.number === null) {
          contingentNumber.number = 1;
        }
        if (contingentNumber.valid_from === null) {
          contingentNumber.valid_from = moment().format("YYYY-MM-DD 00:00:00");
        }
      });
    }

    // Render table for managing contingent_numbers state
    const contingentNumbersCollection = new Backbone.Collection(
      this.model.get("contingent_numbers"),
    );

    contingentNumbersCollection.comparator = (model) =>
      Number(
        model
          .get("valid_from")
          .replace(/-/g, "")
          .replace(":", "")
          .replace(":", "")
          .replace(" ", ""),
      );

    // Note: contingent_numbers can be retrieved back lazily via
    // this.contingentNumbersList.returnFormattedContingentAmounts()
    this.contingentNumbersList = new ContingentNumbersList({
      el: this.$(".contingents-form-numbers__content"),
      collection: contingentNumbersCollection.sort(),
      contingent_id: this.model.get("id"),
    });

    this.model.on("change:resourcetype_id", () => {
      // Change display of form elements according to resourcetype of contingent
      that.$el.attr("data-inb-restype", that.model.get("resourcetype_id"));

      if (that.model.get("resourcetype_id") === 4) {
        that.$el.find(".depend-non-appointment").addClass("hide");
      } else {
        that.$el.find(".depend-non-appointment").removeClass("hide");
      }
    });
  },
});
